export var SocketNamespace;
(function (SocketNamespace) {
    SocketNamespace["Reports"] = "reports";
    SocketNamespace["Chat"] = "chat";
    SocketNamespace["Queries"] = "chat/queries";
    SocketNamespace["Speech"] = "speech";
    SocketNamespace["Projects"] = "projects";
    SocketNamespace["Transcripts"] = "transcripts";
    SocketNamespace["Files"] = "files";
})(SocketNamespace || (SocketNamespace = {}));
export var QuerySocketEvent;
(function (QuerySocketEvent) {
    QuerySocketEvent["QueryTakingTooLong"] = "query/taking-too-long";
    QuerySocketEvent["QueryAvailable"] = "query/available";
    QuerySocketEvent["QueryResponseStreaming"] = "query/response-streaming";
    QuerySocketEvent["QueryErrored"] = "query/errored";
    QuerySocketEvent["QueryFollowupsAvailable"] = "query/followups-available";
    QuerySocketEvent["QueryAudioAvailable"] = "query-audio-available";
    QuerySocketEvent["QueryChainOfThought"] = "query/chain-of-thought";
    QuerySocketEvent["SegmentationResult"] = "segmentation/result";
    QuerySocketEvent["SegmentationCompleted"] = "segmentation/completed";
})(QuerySocketEvent || (QuerySocketEvent = {}));
export var ChatSocketEvent;
(function (ChatSocketEvent) {
    ChatSocketEvent["ChatDeleted"] = "chat-deleted";
})(ChatSocketEvent || (ChatSocketEvent = {}));
export var LifeCycleSocketEvent;
(function (LifeCycleSocketEvent) {
    LifeCycleSocketEvent["Connect"] = "connect";
    LifeCycleSocketEvent["ConnectError"] = "connect_error";
    LifeCycleSocketEvent["Disconnect"] = "disconnect";
})(LifeCycleSocketEvent || (LifeCycleSocketEvent = {}));
export var FileSocketEvent;
(function (FileSocketEvent) {
    FileSocketEvent["ChatAvailable"] = "file-chat-available";
    FileSocketEvent["PreviewAvailable"] = "preview-available";
    FileSocketEvent["TranscriptAvailable"] = "transcript-available";
    FileSocketEvent["UploadAvailable"] = "file-upload-available";
    FileSocketEvent["TagsAvailable"] = "file-tags-available";
})(FileSocketEvent || (FileSocketEvent = {}));
export var ReportSocketEvent;
(function (ReportSocketEvent) {
    ReportSocketEvent["ReportAvailable"] = "report-available";
    ReportSocketEvent["ReportError"] = "report-error";
})(ReportSocketEvent || (ReportSocketEvent = {}));
export var ProjectSocketEvent;
(function (ProjectSocketEvent) {
    ProjectSocketEvent["TranscriptCleanupCompleted"] = "transcript-cleanup-completed";
    ProjectSocketEvent["TranscriptCleanupFailed"] = "transcript-cleanup-failed";
})(ProjectSocketEvent || (ProjectSocketEvent = {}));
export var TranscriptSocketEvent;
(function (TranscriptSocketEvent) {
    TranscriptSocketEvent["RedactionComplete"] = "redaction-complete";
    TranscriptSocketEvent["RedactionError"] = "redaction-error";
    TranscriptSocketEvent["TagSummariesAvailable"] = "tag-summaries-available";
})(TranscriptSocketEvent || (TranscriptSocketEvent = {}));
(function (ProjectSocketEvent) {
    ProjectSocketEvent["TagSummariesAvailable"] = "tag-summaries-available";
    ProjectSocketEvent["TranscriptCleanupEvent"] = "transcript-cleanup-event";
})(ProjectSocketEvent || (ProjectSocketEvent = {}));
